module.exports = __webpack_public_path__ + "static/photo_15-571799c48b597d609ed36a10b0cc25ef.jpg";